import { readFile } from 'node:fs/promises';
import type { LogFn } from '../../../log.js';
import type { PreTurnSnapshotFile } from '../types.js';
import { snapshotFilePath } from '../types.js';

export async function loadPreTurnSnapshot(options: {
  agentCwd: string;
  runId: string;
  log: LogFn;
}): Promise<PreTurnSnapshotFile | null> {
  const { agentCwd, runId, log } = options;
  const filePath = snapshotFilePath(agentCwd, runId);
  try {
    const raw = await readFile(filePath, 'utf8');
    const data = JSON.parse(raw) as PreTurnSnapshotFile;
    if (!Array.isArray(data.repos) || !data.repos.length) {
      log(`[turn-diff] Empty repos in snapshot ${runId.slice(0, 8)}…; skipping aggregate diff.`);
      return null;
    }
    return data;
  } catch (e) {
    log(
      `[turn-diff] No pre-turn snapshot for run ${runId.slice(0, 8)}…: ${e instanceof Error ? e.message : String(e)}`,
    );
    return null;
  }
}
